export default "__VITE_ASSET__BFmTp786__"